export default {
    name: 'Periodicity',

    props: {
        operation: {
            type: Object,
            required: true
        }
    },

    methods: {
        /**
         * Get formatted periodic increment
         * @return {String} formatted periodic increment
         */
        getFormattedPeriodicIncrement() {
            if (!this.operation.per_increase) {
                return '-';
            } else {
                return `${this.operation.per_increase} ${this.operation.per_increase_type === 'LINEAL' ? '€' : '%'}`;
            }
        }
    }
};
